import { render, staticRenderFns } from "./CompanyListIndustry.vue?vue&type=template&id=4fe39155&scoped=true"
import script from "./CompanyListIndustry.vue?vue&type=script&lang=js"
export * from "./CompanyListIndustry.vue?vue&type=script&lang=js"
import style0 from "./CompanyListIndustry.vue?vue&type=style&index=0&id=4fe39155&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe39155",
  null
  
)

export default component.exports